import { combineReducers } from "redux";
import { LOGOUT } from "../../services/types";
import errorReducer from "../../services/error-services/errorReducer";
import blockReducer from "../../services/block-services/blockReducer";
import patternReducer from "../../services/pattern-services/patternReducer";
import projectReducer from "../../services/project-services/projectReducer";
import securityReducer from "../../services/security-services/securityReducer";
import insightsReducer from "../../services/insights-services/insightsReducer";
import structureReducer from "../../services/structure-services/structureReducer";
import activityReducer from "../../services/activity-services/activityReducer";
import {
  scenarioReducer,
  scenarioMetricsReducer,
} from "../../services/scenario-services/scenarioReducer";
import officeReducer from "../../services/office-services/officeReducer";
import dependencyReducer from "../../services/dependency-services/dependencyReducer";
import scheduleActivityReducer from "../../services/schedule-activity-services/scheduleActivityReducer";
import resourceReducer from "../../services/resource-services/resourceReducer";
import attributeReducer from "../../services/attribute-services/attributeReducer";
import quantityReducer from "../../services/quantity-services/quantityReducer";
import calendarReducer from "../../services/calendar-service/calendarReducer";
import userReducer from "../../services/user-services/userReducer";
import usageReducer from "../../services/usage-services/usageReducer";
import tenantsReducer from "../../services/tenant-services/tenantReducer";
import currentUserReducer from "../../services/currentUser/currentUserReducer";
import genericMetricsReducer from "../../services/generic-metrics-services/genericMetricsReducer";
import objectiveReducer from "../../services/objective-service/objectiveReducer";
import {
  UtilsReducer,
  UtilsReducer2,
  UtilsReducer3,
  UtilsReducer4,
} from "../../services/utils-services/utilsReducer";
import standardReducer from "../../services/standard-services/standardReducer";
import tagReducer from "../../services/tag-services/tagReducer";
import VisualPlanningReducer from "../../services/visual-planning-services/visualPlanningReducer";
import VisualInfoReducer from "../../services/visual-info-services/visualInfoReducer";
import MovieReducer from "../../services/movie-services/movieReducer";
import SchedulerReducer from "../../services/scheduler-services/schedulerReducer";
import PortfolioReducer from "../../services/portfolio-services/portfolioReducer";
import aiReducer from "../../services/ai-services/aiReducer";
import aiModelsReducer from "../../services/ai-models-services/aiModelsReducer";
import ResourceSpectrumReducer from "../../services/resource-spectrum-services/resourceSpectrumReducer";
import timelineReducer from "../../services/timeline-services/timelineReducer";
import fontReducer from "../../services/font-services/fontReducer";
import columnPermissionReducer from "../../services/column-permission-services/columnPermissionReducer";
import groupsReducer from "../../services/group-services/groupsReducer";
import columnCustomizationReducer from "../../services/column-customization-services/columnCustomizationReducer";
import apiImportReducer from "../../services/api-import-services/apiImportReducer";
import importReducer from "../../services/import-services/importReducer";
import deleteReducer from "../../services/delete-services/deleteReducer";
import updateUsagesReducer from "../../services/update-usages-services/updateUsagesReducer";
import scenarioCopyReducer from "../../services/scenario-copy-services/scenarioCopyReducer";
import mppBatchImportReducer from "../../services/mpp-batch-import-services/mppBatchImportReducer";
import aiImportReducer from "../../services/ai-import-services/aiImportReducer";
import scenarioDeleteReducer from "../../services/scenario-delete-services/scenarioDeleteReducer";
import auditLogReducer from "../../services/audit-log-services/auditLogReducer";
import auditEventsReducer from "../../services/audit-log-services/auditEventsReducer";
import termCustomizationReducer from "../../services/term-customization-services/termCustomizationReducer";
import portfolioSimulationSettingsReducer from "../../services/portfolio-simulation-settings-services/portfolioSimulationSettingsReducer";
import attributeCustomizationReducer from "../../services/attribute-customization-services/attributeCustomizationReducer";
import actualsReducer from "../../services/actuals-services/actualsReducer";
import autoFeedActualsReducer from "../../services/auto-feed-actuals/autoFeedActualsReducer";
import autofeedReportsReducer from "../../services/autofeed-services/autofeedReportsReducer";
import integrationReducer from "../../services/integration-services/integrationReducer";
import scenarioCompareReducer from "../../services/scenario-compare-services/scenarioCompareReducer";
import projectScenarioCompareReducer from "../../services/project-scenario-compare-services/projectScenarioCompareReducer";
import portfolioScenarioCompareReducer from "../../services/portfolio-scenario-compare-services/portfolioScenarioCompareReducer";
import resetCapacityReducer from "../../services/reset-capacity-services/resetCapacityReducer";
import structureCsvImportReducer from "../../services/structure-csv-import-services/structureCsvImportReducer";
import generativeSchedulingReducer from "../../services/generative-scheduling-services/generativeSchedulingReducer";
import portfolioSimulationReducer from "../../services/portfolio-simulation-services/portfolioSimulationReducer";
import portfolioCopyReducer from "../../services/portfolio-copy-services/portfolioCopyReducer";

const appReducer = combineReducers({
  errors: errorReducer,
  block: blockReducer,
  pattern: patternReducer,
  project: projectReducer,
  security: securityReducer,
  insights: insightsReducer,
  structure: structureReducer,
  activity: activityReducer,
  scenario: scenarioReducer,
  scenarioMetrics: scenarioMetricsReducer,
  office: officeReducer,
  dependency: dependencyReducer,
  scheduleActivity: scheduleActivityReducer,
  resource: resourceReducer,
  attribute: attributeReducer,
  quantity: quantityReducer,
  calendar: calendarReducer,
  usage: usageReducer,
  users: userReducer,
  tenants: tenantsReducer,
  currentUser: currentUserReducer,
  genericMetrics: genericMetricsReducer,
  objective: objectiveReducer,
  standard: standardReducer,
  tag: tagReducer,
  utils: UtilsReducer,
  utils2: UtilsReducer2,
  utils3: UtilsReducer3,
  utils4: UtilsReducer4,
  visualInfo: VisualInfoReducer,
  visualPlanning: VisualPlanningReducer,
  movie: MovieReducer,
  scheduler: SchedulerReducer,
  portfolio: PortfolioReducer,
  ai: aiReducer,
  aiModels: aiModelsReducer,
  resourceSpectrum: ResourceSpectrumReducer,
  timeline: timelineReducer,
  fonts: fontReducer,
  groups: groupsReducer,
  columnPermissions: columnPermissionReducer,
  columnCustomization: columnCustomizationReducer,
  apiImport: apiImportReducer,
  import: importReducer,
  delete: deleteReducer,
  updateUsages: updateUsagesReducer,
  scenarioCopy: scenarioCopyReducer,
  mppBatchImport: mppBatchImportReducer,
  aiImport: aiImportReducer,
  scenarioDelete: scenarioDeleteReducer,
  auditLog: auditLogReducer,
  auditEvents: auditEventsReducer,
  termCustomization: termCustomizationReducer,
  portfolioSimulationSettings: portfolioSimulationSettingsReducer,
  attributeCustomization: attributeCustomizationReducer,
  actuals: actualsReducer,
  autoFeedActuals: autoFeedActualsReducer,
  autofeedReports: autofeedReportsReducer,
  integration: integrationReducer,
  scenarioCompare: scenarioCompareReducer,
  projectScenarioCompare: projectScenarioCompareReducer,
  portfolioScenarioCompare: portfolioScenarioCompareReducer,
  portfolioSimulation: portfolioSimulationReducer,
  portfolioCopy: portfolioCopyReducer,
  resetCapacity: resetCapacityReducer,
  structureCsvImport: structureCsvImportReducer,
  generativeScheduling: generativeSchedulingReducer,
});

// On LOGOUT, reset the ENTIRE store so the next user starts from a clean state.
// combineReducers alone only resets the `security` slice (the only one handling
// LOGOUT), leaking the previous user's data — portfolio, permissions, tenant
// context, cached lists — into the next session on a (reload-free) user switch.
const rootReducer = (state, action) =>
  appReducer(action.type === LOGOUT ? undefined : state, action);

export default rootReducer;
